import { createSlice } from "@reduxjs/toolkit";

export const notifSlice = createSlice({
  name: "notif",
  initialState: {
    inform: {
      open:false,
      message: "",
      severity:"success"
    }
  },
  reducers: {
    informOk: (state, action) => {
      const {message} = action.payload;
      state.inform.message = message;
      state.inform.severity = "success";
      state.inform.open = true;
    },
    informNg: (state, action) => {
      const {message} = action.payload;
      state.inform.message = message;
      state.inform.severity = "error";
      state.inform.open = true;
    },
  },
  extraReducers: (builder) => {},
});

export const { informOk, informNg } = notifSlice.actions;
export const selectInform = (state) => state.notif.inform;
export default notifSlice.reducer;
